import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz23 = () => {
    return (
        <div>
            <NavLink to='/category/Puzzels/Puzzel24'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel22'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <h1 class="title">Days of month using 2 dice</h1>
    
    <div class="text">
        <p><strong><u>Puzzle</u>: </strong>How can you represent days of month using two 6 sided dice? You can write one
            number on each face of the dice from 0 to 9 and you have to represent days from 1 to 31, for example for 1,
            one dice should show 0 and another should show 1, similarly for 29 one dice should show 2 and another should
            show 9.<br/>
             <p>&nbsp;<br/>
                &nbsp;<br/>
                &nbsp;<br/>
                &nbsp;<br/>
                &nbsp;</p>
                <div class="containers">
        <p><strong><u>Answer</u>:</strong><br/>
            <strong>Dice 1:</strong> 0 1 2 3 5 7<br/>
            <strong>Dice 2:</strong> 0 1 2 4 6
            8</p>
        <p><strong><u>Explanation</u>:</strong><br/>
             You have to
            show 11, 22 so 1 and 2 should be present in both dices, similarly to show 01, 09. 0 should be present in
            both dices, now the trick is for showing 9 you can use dice with 6 printed on one of the faces.</p>
        
        <p>Here is the overall representation of all the days in 2 dice:<br/>
   <img
                    src="https://media.geeksforgeeks.org/wp-content/uploads/20191213112304/Days-of-the-month-using-2-dice-solution-1.png"
                    alt="" width="2001" height="1231" class="aligncenter size-full wp-image-1409565"/><br/>
                    &nbsp;</p>
   </div>     </p>
    </div>
</article>
        </div>
    )
}

export default Puz23
